import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  of,
} from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { BACKEND_URL } from '../helpers/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private ADD_USER_URL = `${BACKEND_URL}/users/addUser`;
  private UPDATE_USER_URL = `${BACKEND_URL}/users/updateUser`;
  private USER_LOGIN_URL = `${BACKEND_URL}/users/userLogin`;
  private GET_REGISTERED_USERS_URL = `${BACKEND_URL}/users/getAllRegisteredUsers`;

  constructor(private http: HttpClient) {}

  addUser(user: { email: string, password: string }) {
    return this.http.post(this.ADD_USER_URL, user);
  }

  getAllRegisteredUsers() {
    return this.http.get(this.GET_REGISTERED_USERS_URL);
  }

  updateUser(user: { _id: string, firstName: string, lastName: string, email: string, password: string }) {
    return this.http.put(`${this.UPDATE_USER_URL}/${user._id}`, user);
  }

  userLogin(user: { email: string, password: string }) {
    return this.http.post(this.USER_LOGIN_URL, user)

   // .pipe(
   //   switchMap((r: any) => {
   //     return r.json();
   //   }),
   //   catchError((error: any) => of(error.error)));
  }
}
